import { createReducer, on } from '@ngrx/store';

import { retrieveUser, addUser, updateUser, clearUser } from '../actions/user.actions';
import { User } from 'src/app/shared/interfaces/user.interface';

export const initialState: User = {
  isLoggedIn: false,
  data: {
    _id: '',
    country_name : '',
    country_id : '',
    chain_name : '',
    chain_id : '',
    restaurant_name : '',
    restaurant_id : '',
    employee_id: 0,
    full_name : '',
    phone : '',
    email : '',
    pin : 0,
    employee_card_id : '',
    roles : [],
  },
  token: null,
};

export const userReducer = createReducer(
  initialState,
  on(retrieveUser, (state, { payload }) => payload),
  on(addUser, (state, { payload }) => {
    localStorage.setItem('user-data', JSON.stringify(payload.data));
    return payload;
  }),
  on(updateUser, (state, { payload }) => {
    localStorage.setItem('user-data', JSON.stringify(payload.data));
    return payload;
  }),
  on(clearUser, (state) => {
    localStorage.removeItem('user-data');
    return initialState;
  })
);
